var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22q-3.768 0-6.384-2.559T3 13.195q0-3.109 1.884-5.97Q6.77 4.363 10.06 2.217q.62-.413 1.28-.041T12 3.29v1.431q0 .936.66 1.568.662.633 1.618.633.479 0 .914-.206.436-.207.774-.592a.96.96 0 0 1 .576-.344.83.83 0 0 1 .661.152 8.8 8.8 0 0 1 2.785 3.164 8.7 8.7 0 0 1 1.012 4.1q0 3.687-2.616 6.245T12 22m-6.75-8.805q0 1.432.59 2.71.591 1.28 1.688 2.243A1.3 1.3 0 0 1 7.5 17.9v-.247q0-.88.338-1.651a4.5 4.5 0 0 1 .984-1.403L12 11.545l3.178 3.054q.647.633.985 1.403.337.771.337 1.65v.248q0 .11-.028.248a6.7 6.7 0 0 0 1.687-2.242 6.4 6.4 0 0 0 .591-2.71q0-1.376-.52-2.6a6.7 6.7 0 0 0-1.505-2.188 4.55 4.55 0 0 1-2.447.715q-1.743 0-3.023-1.128T9.778 5.216q-2.194 1.816-3.36 3.866-1.168 2.05-1.168 4.113M12 14.626l-1.603 1.541a2.2 2.2 0 0 0-.478.688 2 2 0 0 0-.169.798q0 .88.66 1.513.662.633 1.59.633t1.59-.633q.66-.633.66-1.513 0-.44-.169-.812a2.2 2.2 0 0 0-.478-.674z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.79f3761a03eff55fb97b698a3ae87000.svg";
export { ForwardRef as ReactComponent };